export enum UserRole {
  SUPER_ADMIN = 'SUPER ADMIN',
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
}
